/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TransactionWithRelations } from '../models/transaction-with-relations';

@Injectable({
  providedIn: 'root',
})
export class TransactionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation transactionControllerFindOneByApiKey
   */
  static readonly TransactionControllerFindOneByApiKeyPath = '/transactions/{paymentIntentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneByAPIKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneByAPIKey$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    paymentIntentId: string;
  }): Observable<StrictHttpResponse<Array<TransactionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TransactionControllerService.TransactionControllerFindOneByApiKeyPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.path('paymentIntentId', params.paymentIntentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TransactionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findOneByAPIKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneByAPIKey(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    paymentIntentId: string;
  }): Observable<Array<TransactionWithRelations>> {

    return this.findOneByAPIKey$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TransactionWithRelations>>) => r.body as Array<TransactionWithRelations>)
    );
  }

}
